import type { ChatSubagentCard } from "./ui-types.ts";
import { startChatFleetSync, type ChatFleetSyncHandle } from "./chat/fleet-chat-sync.ts";
import { buildFleetSSEUrl } from "./chat/fleet-sse-url.ts";

let chatFleetSync: ChatFleetSyncHandle | null = null;

export type FleetSyncHost = {
  settings: { token: string };
  chatSubagents: ChatSubagentCard[];
};

function startChatFleetSyncForHost(host: FleetSyncHost) {
  chatFleetSync?.stop();
  const settingsToken = host.settings.token.trim();
  chatFleetSync = startChatFleetSync({
    getCards: () => host.chatSubagents,
    setCards: (cards) => {
      host.chatSubagents = cards;
    },
    getFleetUrl: () => buildFleetSSEUrl(undefined, { token: settingsToken || undefined }),
  });
}

/** Reconnect fleet SSE after gateway hello (device token may now be available). */
export function restartChatFleetSync(host: FleetSyncHost) {
  startChatFleetSyncForHost(host);
}

export function startChatFleetSyncOnConnect(host: FleetSyncHost) {
  startChatFleetSyncForHost(host);
}

export function stopChatFleetSync() {
  chatFleetSync?.stop();
  chatFleetSync = null;
}
